function EnvelopeIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.8137 88.152C38.8574 87.4151 21.8913 68.9852 22.9893 49.3766C23.9925 31.4616 52.7197 9.93755 73.6271 9.02928C96.4875 8.03617 100.682 32.5028 101.378 52.1498C102.073 71.7495 84.6913 88.8863 61.8137 88.152Z"
        fill="#E6EFFF"
      />
      <path
        d="M76.2868 107.97L56.3146 101.521"
        stroke="#813B19"
        strokeWidth="2.06266"
        strokeLinecap="round"
      />
      <path
        d="M83.1414 27.5039L41.1777 50.7773L58.4507 78.5317L86.8548 85.1436L114.096 68.319L87.2065 28.4787C86.3091 27.1491 84.5442 26.7258 83.1414 27.5039Z"
        fill="#1E6DEB"
      />
      <path
        d="M55.1736 26.8999C55.5317 25.9214 56.5634 25.3636 57.5783 25.5999L111.85 38.2331C113.022 38.5059 113.713 39.7205 113.348 40.8675L106.287 63.0565L102.517 88.1748L44.2934 74.6215L45.0111 67.6818C46.257 55.6345 48.9927 43.7882 53.1554 32.4144L55.1736 26.8999Z"
        fill="white"
      />
      <path
        d="M41.0623 51.2808L58.9498 77.9672L87.3525 84.5787L114.494 68.374L103.722 114.649C103.464 115.758 102.355 116.448 101.245 116.19L31.8319 100.032C30.7224 99.7738 30.0323 98.665 30.2906 97.5555L41.0623 51.2808Z"
        fill="#CCDFFF"
      />
      <path
        d="M57.4775 77.6902L109.253 52.0092C107.585 58.8864 106.497 65.8913 105.999 72.9503L105.971 73.3442L88.7866 84.9783L57.4775 77.6902Z"
        fill="#E6EFFF"
      />
      <line
        x1="55.2638"
        y1="57.1409"
        x2="93.1813"
        y2="65.9672"
        stroke="#0452D0"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <line
        x1="64.6915"
        y1="66.758"
        x2="82.4909"
        y2="70.9013"
        stroke="#0452D0"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <path
        d="M42.0678 51.5148L58.0785 78.5708L87.174 85.3436L112.578 68.7705C113.356 68.2626 114.356 68.9628 114.146 69.8681L103.371 116.155"
        stroke="#1E6DEB"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <path
        d="M58.0401 78.5619L44.4106 88.5253"
        stroke="#1E6DEB"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <path
        d="M87.2113 85.3516L102.892 115.148"
        stroke="#1E6DEB"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <path
        d="M111.477 45.8427C109.315 51.3584 106.681 60.8122 106.205 70.2019"
        stroke="#0452D0"
        strokeWidth="1.34808"
        strokeLinecap="round"
      />
      <circle cx="80.8721" cy="46.1691" r="8.7663" fill="#0DA489" />
      <path
        d="M77.2625 44.6222L78.8095 49.7789L85.5132 42.5596"
        stroke="white"
        strokeWidth="1.95144"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M121.128 112.222L117.231 120.153L125.636 116.193L121.128 112.222Z" fill="#3FB5A0" />
      <path
        d="M144.032 94.4907L118.112 111.159L117.231 120.154L121.128 112.222L144.032 94.4907Z"
        fill="#087463"
      />
      <path d="M111.576 105.406L144.033 94.4907L118.112 111.159L111.576 105.406Z" fill="#B5E8DF" />
      <path d="M144.033 94.4907L121.129 112.222L131.755 121.581L144.033 94.4907Z" fill="#B5E8DF" />
      <path
        d="M143.797 95.2398L131.754 121.581L127.805 118.103"
        stroke="#3FB5A0"
        strokeWidth="1.434"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M49.2873 92.187C49.2873 92.187 11.9563 119.245 18.8324 139.513C25.7085 159.782 67.1501 152.04 111.576 125.183"
        stroke="#8591AC"
        strokeWidth="1.34808"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.7276 133.648C27.7276 133.648 30.1709 152.974 75.3376 133.024"
        stroke="#8591AC"
        strokeWidth="1.34808"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M82.2242 130.151L89.6797 126.663"
        stroke="#8591AC"
        strokeWidth="1.34808"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default EnvelopeIcon;
